import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { AdminUsersPage } from '@/domains/admin';
import { AssistantPage } from '@/domains/assistant';
import { AdminGuard, AuthRedirectPage, LoginPage, PerspectiveGuard, ProtectedRoute } from '@/domains/auth';
import { DocumentsPage, DocumentViewerPage } from '@/domains/documents';
import { EventsPage } from '@/domains/events';
import { AppLayout, NotFound } from '@/domains/general';
import { InformationPage } from '@/domains/information';
import { OverviewPage } from '@/domains/overview';
import { ReportPage } from '@/domains/report';

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/redirect" element={<AuthRedirectPage />} />
        <Route
          element={
            <ProtectedRoute>
              <PerspectiveGuard>
                <AppLayout />
              </PerspectiveGuard>
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/events" replace />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="events/:eventId/overview" element={<OverviewPage />} />
          <Route path="events/:eventId/documents" element={<DocumentsPage />} />
          <Route path="events/:eventId/documents/:documentId" element={<DocumentViewerPage />} />
          <Route path="events/:eventId/report" element={<ReportPage />} />
          <Route path="events/:eventId/information" element={<InformationPage />} />
          <Route path="events/:eventId/assistant" element={<AssistantPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route
            path="admin/:eventId?"
            element={
              <AdminGuard>
                <AdminUsersPage />
              </AdminGuard>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
